import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RouteProps, useNavigate } from 'react-router-dom';
import { RootState } from '../../../redux/types';
import { AppStatus, Type } from '../../../types/instant-lease-api';
import { getAppStatus, getText } from '../../../utils/getter';
import { validateSignerTerms } from '../../../utils/validatetor';
import SignersListAGB from '../../b2b/templates/signers-list-agb/signers-list-agb';
import SignersList from '../../b2b/templates/signers-list/signers-list';
import StatusPage from '../../b2b/templates/status-page/status-page';
import { ReactComponent as CreditPending } from '../images/credit-pending.svg';
import StatusAuthentificationFailed from './status-authentification-failed';
import StatusCancelled from './status-cancelled';
import StatusCompleted from './status-completed';
import StatusCreditFailed from './status-credit-failed';
import StatusFailed from './status-failed';
import StatusPending from './status-pending';
import StatusTimedout from './status-timedout';
import StatusUndefined from './status-undefined';

const LeaseAppStatusOverview: React.FC<RouteProps> = () => {
  // Store
  const { activeApplication } = useSelector(
    (state: RootState) => state.leaseApp,
  );

  // Auth Store
  const { emailVerified } = useSelector((state: RootState) => state.auth);

  // Application status
  const status = getAppStatus(activeApplication);
  // Lease Application Type
  const type = activeApplication?.type as Type;

  // is Signers accepted terms
  const isSignersAcceptedTerms = validateSignerTerms(activeApplication);

  // Navigate hook
  const navigate = useNavigate();

  useEffect(() => {
    if (!emailVerified) {
      navigate('/active-applications/overview');
    }
  }, [emailVerified, navigate]);

  if (status === AppStatus.EsignaturePending) {
    return !isSignersAcceptedTerms ? <SignersListAGB /> : <SignersList />;
  }

  if (type === Type.B2C && status === AppStatus.FinalApprove) {
    return (
      <StatusPage
        heading='Finale Prüfung'
        subHeading='Fast geschafft!'
        image={<CreditPending className='credit-pending' />}
        content={[
          'Bitte hab noch ein wenig Geduld bis die Prüfung deiner Unterlagen final abgeschlossen ist. Bitte beachte dabei unsere Geschäftszeiten (Montag - Donnerstag: 08:00 - 17:00 Uhr Freitag 06:00 - 15:00 Uhr).',
          getText('credit_pending_desc2'),
        ]}
        contentTitle='So geht’s weiter:'
      />
    );
  }

  const renderStatus = () => {
    switch (status) {
      case AppStatus.Completed:
        return <StatusCompleted />;

      case AppStatus.Cancelled:
        return <StatusCancelled />;

      case AppStatus.Failed:
        return <StatusFailed />;

      case AppStatus.CreditFailed:
        return <StatusCreditFailed />;

      case AppStatus.Timedout:
        return <StatusTimedout />;

      case AppStatus.Pending:
        return <StatusPending />;

      case AppStatus.EsignatureFailed:
        return <StatusAuthentificationFailed />;

      case undefined:
        return <StatusUndefined />;

      default:
        return <StatusUndefined />;
    }
  };

  if (activeApplication) {
    return renderStatus();
  }
  return <></>;
};

export default LeaseAppStatusOverview;
